export { SearchAutocompleteResult } from './SearchAutocompleteResult';
export type { ResultItem } from './SearchAutocompleteResult';
